import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Attachment } from '../../../models/attachment';

import * as _ from 'lodash';
import { AttachmentService, TimelinedAttachment } from '../attachment.service';
import { FileManagerService } from '../../file-manager/file-manager.service';
import { ImageHelperService } from '../../image-helper/image-helper.service';
import { buildAttachmentDownloadName } from '../../file-manager/attachment-download-name';

@Component({
  selector: 'tn-attachment-image-grid',
  templateUrl: './attachment-image-grid.component.html',
  styleUrls: ['./attachment-image-grid.component.scss']
})
export class AttachmentImageGridComponent implements OnInit {
  attachments: Attachment[] = [];
  attachmentIds: string[] = [];
  // Parallel to attachmentIds - see AttachmentImageComponent.resolveDefaultIndex.
  attachmentMessageIds: string[] = [];
  // Download names keyed per copy (ImageHelperService.buildAttachmentKey), as in
  // ChatRoomComponent.onMessageClick.
  filenameMap: {[attachmentKey: string]: string} = {};

  timelinedAttachments: TimelinedAttachment[] = [];

  constructor(
    public dialogRef: MatDialogRef<AttachmentImageGridComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _fileManagerService: FileManagerService,
    private _attachmentService: AttachmentService,
    private _imageHelperService: ImageHelperService
  ) { }

  ngOnInit() {
    this.attachments = this.data.attachments;
    this.parseImages();
  }

  parseImages(): void {
    _.each(this.attachments, (a) => {
      if (this._fileManagerService.checkIfAttachmentIsGif(a.filename)) {
        // a.imgSrc = this._fileManagerService.getBackgroundImgSrcByAttachmentId(a.attachment_id);
        // return; // continue
        a.isGif = true;
      }

      a.imgSrc = this._fileManagerService.getBackgroundImgSrcByBase64(a.preview_image, a.content_type);
    });

    this.attachmentIds = _.map(this.attachments, 'attachment_id');
    this.attachmentMessageIds = _.map(this.attachments, 'message_id');

    // The opener decides the prefix (GENERAL.DOWNLOAD_FILE_WITH_PREFIX).
    const prefix = this.data.downloadNamePrefix || '';
    this.filenameMap = {};
    _.each(this.attachments, (a) => {
      const attachmentKey = this._imageHelperService.buildAttachmentKey(a.attachment_id, a.message_id);
      this.filenameMap[attachmentKey] = buildAttachmentDownloadName(a, {prefix});
    });

    this.attachments = _.orderBy(this.attachments, 'timestamp', 'desc');

    this.timelinedAttachments =  this._attachmentService.buildTimelinedAttachments(this.attachments);
  }

  onClick(image: Attachment): void {
    this._attachmentService.prepareAttachmentModalContentByFileId(
      this.attachmentIds,
      image.attachment_id,
      this.data.editImageCallbackWithImageUrlAndCaption,
      null,
      null,
      false,
      true,
      this.filenameMap,
      this.attachmentMessageIds,
      image.message_id
    );
  }

}
